/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
  "underscore",
  "backbone",
  "utils/dom",
  "utils/jsonpath",
  "utils/object",
  "i18n/i18n"
], function(
  _,
  Backbone,
  dom,
  JSONPath,
  MBObject,
  i18n
) {

  var Schema = function (options) {
    options = options || {};
    this.inputAttributes = options.inputAttributes || {};
    this.attributes = options.attributes || {};
    var inputKeys = _.keys(this.inputAttributes);
    for (var i = 0; i < inputKeys.length; ++i) {
      var key = inputKeys[i];
      this.attributes[key] = this.inputAttributes[key];
      this.attributes[key].model_stored = true;
    }
    this.inputAttributeNames = [];
    var keys = _.keys(this.attributes);
    for (var j = 0; j < keys.length; ++j) {
      var key = keys[j];
      var att = this.attributes[key];
      if (att.model_stored) {     
        this.inputAttributeNames.push(key);
      }
    }
    
    this.content = options.content;

    var that = this;
    this.addAdditionalAttrs = function (additionalAttrs) {
      var obj = {
        inputAttributeNames: that.inputAttributeNames,
        attributes: that.attributes,
        inputAttributes: that.inputAttributes
      };
      var mergedObj = MBObject.merge(obj, additionalAttrs);

      this.inputAttributes = mergedObj.inputAttributes;
      this.attributes = mergedObj.attributes;
      this.inputAttributes = mergedObj.inputAttributes;
    }
  };

  _.extend(Schema.prototype, Backbone.Events, {

    // attributes named abcDef can be specified using data-abc-def
    // false for compatibility reasons
    // API components (Templates.add) set this to true automatically
    useCamelCaseNames: false,

    parseAttributes: function (attributes, options) {
      var that = this;
      var options = options || {};
      var outAttributes = options.schemaOnly ? {} : attributes;
      _.each(this.attributes, function (unused, key) {
        var defaultValue = undefined;
        var value = that.parseAttribute(attributes[key], key, defaultValue, {errorContext: options.errorContext});
        if (value != null ) {
          outAttributes[key] = value;
        }
      });
      
      return outAttributes;
    },

    getSchema: function(key) {
      var foundAttr = this.attributes[key];
      if (foundAttr) return foundAttr;

      // try to find attribute by converting the name camel case to kebap case
      var kebapCaseAttrName = dom.AttributeModel.camelCaseToSeparated(key);
      foundAttr = this.attributes[kebapCaseAttrName];

      return foundAttr;
    },

    validateInput: function(value, key) {
      var schema = this.getSchema(key);
      var type = (schema && schema.type) || "string";

      switch (type) {
      case "int":
        if (isNaN(parseInt(value))) {
          return {ok: false, error: "Number expected!"};
        }
      }
      return {ok: true};
    },

    parseAttribute: function (value, key, defaultValue, options) {
      var schema = this.getSchema(key),
          type = (schema && schema.type) || "string",
          defaultValue = defaultValue === undefined ? (schema && schema["default"]) : defaultValue;
      var options = options || {};
      if (defaultValue === null) defaultValue = undefined;
      var errorContext = "";
      if (_.isFunction(options.errorContext)) {
        errorContext = options.errorContext();
      }
      else if (_.isString(options.errorContext)) {
        errorContext = options.errorContext;
      }

      switch (type) {
       case "QueryExpr": {
         if (_.isObject(value) && !_.isEmpty(value)) {
           return value;
         }
         if (_.isString(value) && !_.isEmpty(value)) {
           try {
             return JSON.parse(value);
           } catch (e) {
             return { "unparsed": value}
           }
         }
         return defaultValue;
       }
       case "boolean": return new RegExp("^" + !!!defaultValue + "$", "i").test(value) ? !defaultValue : !!defaultValue;
       case "int": return value ? parseInt(value, 10) : defaultValue;
       case "float": return value ? parseFloat(value) : defaultValue;
       case "date": return value ? new Date(value) : defaultValue;
       case "SearchRequest": return value ? JSON.parse(value) : defaultValue;
       case "list": if (value) { try { return JSON.parse(value); } catch (e) { return value.split(/\s*,\s*/) } }; return defaultValue;
       case "json": if (value) { try { return JSON.parse(value); } catch (e) { return value.split(/\s*,\s*/) } }; return defaultValue;
       case "keyValue": {
         if (value) {
           try {
             return JSON.parse(value); 
           } catch (e) {
             if (console && console.warn) {
               console.warn("Failed to parse data for type 'keyValue'", errorContext, e);
             }
           }
         }
         return defaultValue;
       }
       case "i18nString": return i18n.translateIfPrefixed(value ? value : defaultValue);
      }

      return value || defaultValue;
    },

    serializeAttribute: function (value, key) {
      var schema = this.getSchema(key),
          type = (schema && schema.type) || "string";

      switch (type) {
       case "QueryExpr": return value ? ( _.keys(value).length == 1 && value.unparsed ? value.unparsed : JSON.stringify(value) ) : undefined;
       case "int": return value ? value.toString() : undefined;
      }

      return value;
    },

    filterInputAttributes: function (attributes) {
      var inputAttributeNames = this.inputAttributeNames,
          filteredAttributes = {},
          that = this;

      _.each(attributes, function (value, key) {
        if (_.indexOf(inputAttributeNames, key) >= 0) {
          filteredAttributes[key] = value;
        }
      });

      return filteredAttributes;
    },

    optionsAsAttributes: function (options) {
      var that = this;
      return _.map(options, function (value, key) {
          return "data-" + key + "=" + that.serializeAttribute(value, key);
      }).join(' ');
    }
  });

  return Schema;
});
